
export enum VideoDisplayMode
{
	COVER = "cover",
	FIT = "contain",
}
